import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['corporationId', 'role', 'communities']
  roles = ['corporate', 'support', 'admin']

  connect() {
    // converts select2 events into native events
    $('#corporate_user_corporation_id').on('select2:select', function() {
      let event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    });
    this.toggleCommunities()
  }

  selectAll(e) {
    let checked = e.target.checked
    $('.choice input[type="checkbox"').prop('checked', checked)
  }

  toggleCommunities() {
    let corporationId = this.corporationIdTarget.value;
    let role = this.roleTarget.value

    if (this.roles.includes(role) || corporationId == '') {
      this.removeCommunities()
    } else {
      this.getCommunities(corporationId)
    }
  }

  getCommunities(corporationId) {
    let corporateUserId = $('#corporate_user_id').val()
    let communities = document.getElementsByClassName('choices-group')[0];
    let selectAll = document.getElementById('corporate_user_select_all_input')

    if (corporationId) {
      $.get({
        url: '/admin/corporate_users/get_communities',
        data: {
          corporation_id: corporationId,
          corporate_user_id: corporateUserId
        },
        success: (results) => {
          $('#corporate_user_communities_input').removeClass('visually-hidden')
          $(selectAll).detach()
          $(communities).replaceWith(`<div>${results}</div>`)
        }
      })
    }
  }

  removeCommunities() {
    let communities = document.getElementsByClassName('choices-group')[0];
    let selectAll = document.getElementById('corporate_user_select_all_input')

    $('#corporate_user_communities_input').addClass('visually-hidden')
    $(selectAll).detach()
    $(communities).replaceWith('<div class="choices-group"></div>')
  }
}
